import styles from "./ErrorHandler.module.css";
import defaultImg from "../../asset/components/error-handler/err.webp";
import defaultImgMb from "../../asset/components/error-handler/err2x.webp";
import homeIcon from "../../asset/components/error-handler/home-icon.webp";
import { useNavigate } from "react-router-dom";
import useWindowDimensions from "../../hooks/useWindowDimensions";
//import { useEffect, useState } from "react";

export function ErrorFallback({ error, resetErrorBoundary }) {
  //console.log(error.message);

  const navigate = useNavigate();
  const { width } = useWindowDimensions();
  let handleErrorMessage = `Uncaught SyntaxError: Unexpected token '<'`;
  const isRefreshReqd = error?.message === handleErrorMessage;
  const handleRefresh = () => {
    window.location.reload();
  };

  // const [count, setCount] = useState(1);

  // useEffect(() => {
  //   setCount(JSON.parse(window.sessionStorage.getItem("count")));

  //   if (
  //     JSON.parse(window.sessionStorage.getItem("count")) < 3 &&
  //     isRefreshReqd
  //   ) {
  //     setCount((c) => c + 1);
  //     window.location.reload();
  //     // console.log(count);
  //   } else if (!isRefreshReqd) {
  //     window.sessionStorage.setItem("count", 1);
  //   }

  //   // return () => {
  //   //   window.sessionStorage.setItem("count", 1);
  //   // };
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [isRefreshReqd]);

  // useEffect(() => {
  //   window.sessionStorage.setItem("count", count);
  //   // return () => {
  //   //   window.sessionStorage.setItem("count", 1);
  //   // };
  // }, [count]);

  console.log("Error");

  return (
    <div className={styles.error}>
      {width < 500 ? (
        <img src={defaultImgMb} alt="error" className={styles.img} />
      ) : (
        <img src={defaultImg} alt="error" className={styles.img} />
      )}
      <h1 className={styles.h1}>
        <span>Ooops !!!</span> <span>Something went wrong</span>{" "}
      </h1>
      <p className={styles.p}>
        We have encountered an unusual issue. Please check your internet and
        refresh this page or try after sometime.
      </p>
      {isRefreshReqd ? (
        <button className={styles.btn} onClick={handleRefresh}>
          Refresh
        </button>
      ) : (
        <button className={styles.btn} onClick={() => navigate("/")}>
          <img src={homeIcon} alt="home" className={styles.home} /> Go to home
        </button>
      )}
    </div>
  );
}
